import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import Box from '@mui/material/Box';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../themeContext';
import clearCookies from '../../../util/storage/clearCookies';
import clearLocalStorage from '../../../util/storage/clearLocalStorage';
import { setIsNavigationDropdownOpened } from '../../../redux/features/general/navigation';
import moment from 'moment';
import SettingsRow from '../../doctor/navigation/navBar/SettingsRow';
import { LogoutOutlined } from '@mui/icons-material';

type Props = {
    children?: React.ReactNode
};

const Settings: React.FC<Props> = ({children}) => {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch(); 
    const location = useLocation();

    const colors = useAppSelector(state => state.theme.colors);
    const accountInfo = useAppSelector(state => state.meta.accountInfo); 
    const groupAccess = useAppSelector(state => state.group.groupAccess); 

    const isNavigationDropdownOpened = useAppSelector(state => state.navigation.isNavigationDropdownOpened);

    const [timeLeft, setTimeLeft] = useState(2); 
    const [isHovering, setIsHovering] = useState(false);

    const [navbarTime, setNavbarTime] = useState(''); 
    const [settingsTimeLeft, setSettingsTimeLeft] = useState(0); 

    // -- 

    document.addEventListener('mousedown', function(e) {

        if (isNavigationDropdownOpened) { 

            if (!isHovering) { 

                setSettingsTimeLeft(2); 
    
            };

        }; 

    });

    // -- 

    const handleDropdown = () => { 

        dispatch(setIsNavigationDropdownOpened(!isNavigationDropdownOpened)); 
        setSettingsTimeLeft(0);

    }; 

    // -- 

    const handleLockScreen = () => { 

        localStorage.setItem('isScreenLocked', 'on');

        navigate('/lock/screen'); 

    }; 

    // -- 

    useEffect(() => {

        dispatch(setIsNavigationDropdownOpened(false)); 

    },[location.pathname]); 

    // -- 


    useEffect(() => {
        let myInterval = setInterval(() => {
          if (timeLeft > 0) {
            setTimeLeft(timeLeft - 1);
          }
      
          if (timeLeft === 1) {
            // Set locale based on i18n language
            moment.locale(i18n.language);
      
            const formatted = moment().utc(true).format('LLLL');
            setNavbarTime(formatted.charAt(0).toUpperCase() + formatted.slice(1));
            setTimeLeft(2);
          }
      
          if (timeLeft === 0) {
            clearInterval(myInterval);
          }
        }, 500);
      
        return () => {
          clearInterval(myInterval);
        };
      }, [timeLeft, i18n.language]);

      // -- 

      useEffect(() => {
        let myInterval = setInterval(() => {
          if (settingsTimeLeft > 0) {
            setSettingsTimeLeft(timeLeft - 1);
          }
      
          if (settingsTimeLeft === 1) {

            dispatch(setIsNavigationDropdownOpened(false)); 

          }
      
          if (settingsTimeLeft === 0) {
            clearInterval(myInterval);
          }
        }, 100);
      
        return () => {
          clearInterval(myInterval);
        };
      }, [settingsTimeLeft]);

    return (


        <Box
            sx={{ 
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space',
                position: 'absolute', 
                right: '2vw', 
            }}
        >

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: 1,
                    fontSize: 12, 
                    color: 'rgb(150, 150, 150)'
                }}
                >{`${accountInfo?.firstName} ${accountInfo?.lastName}`}
            </Box>

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: 1,
                    fontSize: 12, 
                    color: 'rgb(150, 150, 150)'
                }}
                >{`|`}
            </Box>

            <Box
                sx={{ 
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: 2,
                    fontSize: 12, 
                    color: 'rgb(150, 150, 150)'
                }}
            >{navbarTime}
            </Box>

            <AccountCircleIcon 
                onClick={handleDropdown}
                sx={{ 
                    cursor: 'pointer', 
                    color: isNavigationDropdownOpened ? colors?.main : 'rgb(100, 100, 100)',
                    '&:hover': { color: colors?.mainHover }
                }} />
            
                <Box
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                    sx={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        alignItems: 'center', 
                        justifyContent: 'space-evenly',
                        width: 200,
                        height: isNavigationDropdownOpened ? 40 : 0,
                        top: 30, 
                        right: 0, 
                        position: 'absolute',
                        backgroundColor: colors?.fileExplorerDropdown,
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                        borderRadius: 4,
                        zIndex: 10000000, 
                        transition: 'height 0.3s',
                    }}
                >

                    {isNavigationDropdownOpened && 
                    
                    <>

                        <SettingsRow section={'logout'} >
                            <LogoutOutlined /> 
                        </SettingsRow>

                    </>}

                </Box>

        </Box>
    );
};

export default Settings;